import { useMemo } from "react";

import CloudinaryImage from "@/components/cloudinary-image";
import CustomCheckbox from "@/components/custom-checkbox";

import type { UserType } from "./types";

interface UserProps {
  isSelected: boolean;
  onToggle(user: UserType): void;
  user: UserType;
}

export default function User({ isSelected, onToggle, user }: UserProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    event.preventDefault();

  const handleToggle = () => onToggle(user);

  const fullName = useMemo(() => {
    const names: string[] = [];

    if (user.firstName) {
      names.push(user.firstName);
    }
    if (user.lastName) {
      names.push(user.lastName);
    }

    return names.join(" ");
  }, [user.firstName, user.lastName]);

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: dont worry about it
    // biome-ignore lint/a11y/useKeyWithClickEvents: dont worry about it
    // biome-ignore lint/a11y/noNoninteractiveElementInteractions: legacy
    <div
      className="flex cursor-pointer items-center gap-2.5"
      data-testid="user-row"
      onClick={handleToggle}
    >
      <CloudinaryImage
        className="size-10 rounded-full"
        rW={80}
        size={40}
        user={user}
      />
      <div className="flex grow-1 flex-col items-start">
        <h5 className="font-medium text-13/[1.5em] text-white">
          {user.username}
        </h5>
        <h6 className="font-normal text-13/[1.5em] text-heather">{fullName}</h6>
      </div>
      <CustomCheckbox defaultChecked={isSelected} onChange={handleChange} />
    </div>
  );
}
